var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"boxy"},[_c('div',{staticClass:"loader"}),(_vm.showLabel)?_c('label',[_vm._v(_vm._s(_vm.$t(_vm.labelText))+"...")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }